// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"93":"b459238eff2ada7dd934","264":"ffb561973751ce4e29f4"}[chunkId] + ".chunk.js";
};